const vibrateApi = (duration = 1000) => {
  if ("vibrate" in navigator) {
    console.log("vibrating for " + duration)
    navigator.vibrate(duration)
  } else console.log("No vibration in this browser")
}

export default vibrateApi
